module.exports = __webpack_public_path__ + "static/media/undraw.a10983eb.svg";